export const translations = {
    it: {
        nav: {
            trail: "Trail", video: "Video", storia: "Storia", community: "Community", eventi: "Eventi", shop: "Shop", arcade: "Arcade", guide: "Guide", rideCall: "Ride Call", stay: "Stay",
            rides: "Rides", abnormal: "Abnormal", murph: "Murph", trailReport: "Trail Report", story: "Story",
            login: "Login", join: "Unisciti", logout: "Esci", admin: "Admin", settings: "Settings",
        },
        footer: {
            tagline: "MTB Enduro sul Monte Argentario. L'hub di trail, foto e community per chi ama girare in Toscana.",
            sections: "Sezioni", info: "Info", legal: "Legale",
            privacy: "Privacy Policy", cookie: "Cookie Policy", shipping: "Spedizioni", returns: "Resi e rimborsi", terms: "Condizioni di vendita",
            madein: "MADE IN ARGENTARIO", copyright: "MTB Enduro Argentario",
        },
        home: {
            eyebrow: "// INDEPENDENT THINKING / ENDURO MTB / ARGENTARIO",
            titleL1: "Abnormal", titleL2: "world", titleL3: "",
            tagline: "Enduro MTB · Monte Argentario",
            subtitle: "Le mappe aiutano. La curiosità di più. {n} trail. Zero algoritmi.",
            ctaTrails: "Scopri i Trail",
            ctaReport: "Trail Report",
            ctaVideo: "Guarda i Video",
            ctaRide: "Prossimo Ride",
            ctaShop: "Shop Drop",
            ctaCommunity: "Entra nella Community",
            ctaArcade: "Scopri Arcade",
            ctaStory: "La storia Abnormal",
            howEyebrow: "COME FUNZIONA",
            howTitle1: "Cinque mosse,",
            howTitle2: "zero giri di parole.",
            howStep1Title: "Controlla i trail",
            howStep1Sub: "Stato dei sentieri, fondo, segnalazioni recenti.",
            howStep2Title: "Trova o crea un Ride",
            howStep2Sub: "Pubblica il giro o uniscit. Niente WhatsApp infiniti.",
            howStep3Title: "Sblocca le sfide",
            howStep3Sub: "Quest Argentario Stages, verifica via Strava, badge.",
            howStep4Title: "Eventi & community",
            howStep4Sub: "Gare, raduni, foto, video, persone reali.",
            howStep5Title: "Supporta la scena",
            howStep5Sub: "Gear Abnormal, partner locali, builder.",
            sectionsEyebrow: "Le sezioni", sectionsTitle1: "Trova subito", sectionsTitle2: "quello che cerchi",
            qaTrail: { title: "Trail", sub: "Linee e schede tecniche" },
            qaCommunity: { title: "Community", sub: "Chi gira all'Argentario" },
            qaShop: { title: "Shop", sub: "Tessuto Abnormal" },
            qaArcade: { title: "Arcade", sub: "Sfide. Non è un gioco." },
            qaRide: { title: "Ride Call", sub: "Pubblica giri, trova compagni" },
            qaStay: { title: "Stay & Sea", sub: "Hotel, piscina, mare a 200 m" },
            featuredEyebrow: "IN EVIDENZA", featuredBadge: "Trail del mese", featuredCta: "Scopri il trail",
            difficulty: "Difficoltà", length: "Lunghezza", elevation: "Dislivello D−",
            communityEyebrow: "COMMUNITY", communityTitle1: "Unisciti alla", communityTitle2: "community", communityTitle3: "Abnormal",
            communitySub: "Rider locali, foto, consigli e passaggi condivisi. Un posto semplice per chi gira all'Argentario e per chi vuole farlo.",
            communityCta: "Entra nella community",
            shopEyebrow: "DROP ABNORMAL",
            shopTitle1: "Vesti come",
            shopTitle2: "la crew.",
            shopSub: "Ogni drop nasce dalla stessa roba che trovi sui trail: errori, polvere, lividi, salite odiate e discese rifatte mille volte. Niente catwalk, solo gear vero.",
            shopCtaAll: "Tutto lo shop",
        },
        shopPromo: {
            eyebrow: "DROP ABNORMAL",
            title: "Vesti come la crew.",
            sub: "Gear pensato per chi gira davvero. Spedizioni rapide, taglie limitate.",
            cta: "Apri lo shop",
        },
        trails: {
            eyebrow: "TRAIL REPORT", title1: "Trail", title2: "Argentario",
            subtitle: "Stato live di ogni trail dell'Argentario aggiornato dai rider: chi è aperto, chi è chiuso, chi ha bisogno di attenzione. Info pratiche, livello tecnico, link diretto a Komoot e Google Maps.",
            mapTracks: "Mappa tracce", trailforks: "Trailforks — Monte Argentario",
            heatmap: "Heatmap", strava: "Strava — Argentario",
            difficulty: "Difficoltà", terrain: "Terreno", all: "Tutti",
            easy: "Facile", medium: "Medio", hard: "Hard",
            rock: "Roccia", flow: "Flow", technical: "Tecnico", mixed: "Misto",
            empty: "Nessun trail con questi filtri.", cardCta: "Scheda",
            badgeMonth: "Trail del mese",
            statusFilter: "Stato",
            stateOpen: "Aperto", stateWarning: "Attenzione", stateClosed: "Chiuso", stateUnverified: "Da verificare", stateUnverifiedNote: "Stato non aggiornato di recente: controlla meteo e trail report su Trailforks prima di partire.",
            statsTotal: "Trail totali", statsOpen: "Asciutti verificati", statsWarning: "Bagnati / attenzione", statsClosed: "Chiusi",
            metaTerrain: "Terreno", metaLength: "Lung.", metaElev: "D−",
            lastUpdated: "Aggiornato",
            justNow: "ora", minShort: "min", hourShort: "h", dayShort: "g",
            resetFilters: "Reset filtri",
            show: "Mostra", hide: "Nascondi",
        },
// Remove redundant comment
        weather: {
            eyebrow: "Meteo in tempo reale",
            title: "Argentario adesso",
            wind: "Vento", rain: "Pioggia", feels: "Percepita",
            updated: "Aggiornato", source: "Fonte: Open-Meteo",
            loading: "Carico meteo…", error: "Meteo non disponibile.",
            forecastTitle: "Prossimi 3 giorni",
            min: "Min", max: "Max", precip: "Pioggia",
            today: "Oggi", tomorrow: "Domani",
            codes: {
                clear: "Sereno", mainlyClear: "Poco nuvoloso", partlyCloudy: "Parzialmente nuvoloso", overcast: "Coperto",
                fog: "Nebbia", drizzle: "Pioggerella", rain: "Pioggia", heavyRain: "Pioggia forte",
                snow: "Neve", thunderstorm: "Temporale", showers: "Rovesci", unknown: "—", variable: "Variabile",
            },
        },
        trailDetail: {
            back: "Tutti i trail", line: "LA LINEA", tips: "CONSIGLI REALI",
            noteFondo: "NOTE SUL FONDO",
            video: "VIDEO", map: "MAPPA", trailforksOpen: "Apri su Trailforks", trailforksSub: "Traccia GPS + elevation",
            difficulty: "Difficoltà", terrain: "Terreno", length: "Lunghezza", elevation: "Dislivello D−",
            safetyTitle: "IN SICUREZZA",
            safetyText: "Casco e protezioni obbligatorie. Se una linea non ti torna, fermati e ripensala. Divertirsi senza farsi male è la regola base.",
            notFound: "Trail non trovato", notFoundBack: "← Torna ai trail", loading: "Caricamento…",
            openOnMap: "Apri su mappa",
        },
        community: {
            eyebrow: "COMMUNITY",
            title1: "La", title2: "community",
            sub: "Foto, rider, realtà locali. Un posto solo per raccontare l'enduro al Monte Argentario.",
            partnersEyebrow: "INSIEME A NOI",
            partnersTitle: "Argentario Bike, Tuscan Hill Enduro, Goat Trails e Bike Point sostengono insieme ad Abnormal l'enduro al Monte Argentario.",
            riderEyebrow: "RIDER LOCALI", riderTitle: "La scena dell'Argentario",
            adminMode: "Admin mode", riderEmpty: "Galleria in aggiornamento.", riderEmptyAdmin: "Nessuna foto ancora. Aggiungila dal form qui sopra.",
            riderPhoto: "Foto rider", riderName: "Nome rider", riderCaption: "Descrizione (opzionale)",
            riderSubmit: "Aggiungi rider", riderUploading: "Carico…",
            userEyebrow: "FOTO DALLA COMMUNITY", userTitle: "Manda la tua foto",
            userSub: "Registrati e carica le foto tue e del tuo gruppo, direttamente dal telefono o dal computer.",
            photo: "Foto", caption: "Didascalia (opzionale)", captionPh: "Dove, con chi, cosa è successo",
            submit: "Pubblica foto", submitting: "Pubblico…",
            loginReq1: "Per caricare foto,", loginReq2: "registrati alla community",
        },
        shop: {
            eyebrow: "MERCH", title1: "Shop", title2: "Abnormal",
            sub: "T-shirt, felpe, cappelli. Design Abnormal, checkout sicuro Shopify direttamente qui.",
            addBtn: "Nuovo prodotto",
            empty: "Nessun prodotto ancora.", emptyAdmin: "Click su \"Nuovo prodotto\" per aggiungerne uno.",
            buy: "Compra", soon: "Presto",
        },
        eventi: {
            eyebrow: "Sponsor ufficiale",
            title1: "Tuscany Urban", title2: "Cup",
            p1pre: "ABNORMAL è sponsor ufficiale della",
            p1strong: "Tuscany Urban Cup",
            p1post: ", il circuito di gare MTB che unisce l'Enduro con l'anima urban della Toscana.",
            p2: "Tutte le date, iscrizioni e aggiornamenti sulle gare sul profilo Instagram ufficiale del circuito.",
        },
        storia: {
            eyebrow: "IL PROGETTO",
            title1: "Il Progetto", title2: "Abnormal",
            p1pre: "", p1strong: "ABnormalworld", p1post: " nasce per dare visibilità alla scena enduro del Monte Argentario: trail, builder, rider, eventi e persone che tengono vivo il movimento. Non è turismo finto. È territorio visto da chi ci gira davvero.",
            p2: "Niente brochure, niente storytelling da agenzia. Foto vere, condizioni vere, persone vere. Quello che vedi qui è quello che trovi quando carichi la bici in macchina e vieni a girare.",
            p3: "Sul sito trovi: trail report aggiornati dalla community, ride call per organizzare giri senza WhatsApp infiniti, eventi, sfide Arcade verificate via Strava, guide, gallery, partner locali e gear ABnormal.",
            p4: "Una community che cresce, legata ai trail, alle persone e a tutto quello che gira intorno alla MTB fatta sul serio. Vieni a girare con noi.",
        },
        auth: {
            loginEyebrow: "ACCESSO", loginTitle: "Entra.",
            loginSub: "Niente social, solo email. Rapido, brutto, efficace.",
            email: "Email", password: "Password",
            loginBtn: "Login", loginBusy: "…",
            noAccount: "Non hai un account?", goRegister: "Registrati",
            forgot: "Password dimenticata?",
            regEyebrow: "UNISCITI", regTitle: "Dentro.",
            regSub: "Carica foto, firma le linee, lascia la traccia.",
            name: "Nome o Nickname", passwordMin: "Password (min. 6)",
            regBtn: "Registrati",
            hasAccount: "Hai già un account?", goLogin: "Login",
            welcomeBack: "Bentornato. Gira forte.", welcomeNew: "Benvenuto nella community Abnormal.",
            forgotEyebrow: "PASSWORD DIMENTICATA",
            forgotTitle: "Recupera l'accesso.",
            forgotSub: "Inserisci la mail con cui ti sei registrato. Se l'account esiste, ti mandiamo subito un link per scegliere una nuova password (valido 1 ora).",
            forgotBtn: "Invia link",
            forgotSent: "Se l'email è registrata, controlla la casella tra qualche istante.",
            backToLogin: "Torna al login",
            resetEyebrow: "RESET PASSWORD",
            resetTitle: "Nuova password.",
            resetSub: "Scegli una password robusta. Minimo 6 caratteri.",
            resetBtn: "Aggiorna password",
            resetOk: "Password aggiornata. Ora puoi accedere.",
            resetMissing: "Token mancante o non valido. Richiedi un nuovo link.",
        },
        cookie: {
            message: "Questo sito usa cookie tecnici e, con il tuo consenso, cookie di analytics. Puoi accettare tutto, rifiutare o leggere la nostra",
            messageLink: "Cookie Policy",
            accept: "Accetta", decline: "Solo essenziali", settings: "Preferenze",
        },
        guide: {
            eyebrow: "Argentario Guides",
            title1: "Argentario", title2: "Guides",
            subtitle: "Guide vere per chi viene a girare all'Argentario o per chi ci vive e vuole spremere meglio i trail. Niente brochure. Solo informazioni utili, dritte locali e un po' di sana polvere nei denti.",
            empty: "Guide in arrivo.",
            read: "Read guide",
            back: "Tutte le guide",
            notFound: "Guida non trovata",
            relatedTrails: "Trail collegati",
            beforeTitle: "Prima di partire",
            beforeText: "I trail cambiano. Pioggia, vento, manutenzione, caldo e passaggi continui possono modificare il fondo da un giorno all'altro. Prima di organizzare un'uscita controlla sempre lo stato aggiornato su Trailforks, Strava, Argentario Bike o chiedi alla community locale.",
            beforeCta: "Check trail status",
            quickEyebrow: "Trail Quick Notes",
            quickSub: "Due righe sporche sui trail più nominati dell'Argentario. Non sostituiscono una guida, ma ti evitano di partire completamente al buio.",
            outro: "ABNORMAL non vende la favola del trail perfetto. Racconta il territorio com'è: bello, ruvido, tecnico, vivo. Se lo rispetti, ti dà tantissimo. Se lo prendi sottogamba, ti spiega due cose.",
        },
        common: {
            error: "Errore",
            loading: "Caricamento…",
            uploadFile: "Carica file",
            uploading: "Caricamento…",
            confirmPassword: "Conferma password",
            passwordsMismatch: "Le password non coincidono",
            share: "Condividi",
            shareTrail: "Condividi trail",
            copyLink: "Copia link",
            copyCaption: "Copia caption IG",
            copied: "Copiato negli appunti",
            copyFail: "Impossibile copiare",
            uploadPhotoFirst: "Carica una foto.",
            uploadOrPaste: "Carica una foto o incolla un URL.",
            save: "Salva",
            publish: "Pubblica",
            soonDesc: "Sistema livelli, ranking, sfide reali ed eventi in arrivo.",
        },
        arcade: {
            insertCoin: "★ INSERT COIN ★ INSERT COIN ★",
            tagline: "> NON È UN GIOCO. MA QUASI.",
            sub1: "> OGNI LIVELLO È UNA SFIDA REALE.",
            sub2: "> SOLO PER CHI NON CERCA SCUSE.",
            unlocking: "UNLOCKING SOON…",
            ready: "READY PLAYER ONE",
            prepare: "PREPARE YOURSELF",
            copy: "Sistema livelli, ranking, sfide reali ed eventi in arrivo.",
            copy2: "Stage 1 giocabile. Gli altri si sbloccheranno.",
            hiscore: "HI-SCORE COMING SOON",
        },
        newsletter: {
            eyebrow: "Newsletter",
            title1: "Resta nel", title2: "giro",
            sub: "Niente spam. Solo nuove linee, eventi sull'Argentario e novità dallo shop. Una email ogni tanto, quando c'è davvero qualcosa da dire.",
            placeholder: "la-tua@email.com",
            cta: "Iscriviti", busy: "Invio…",
            consent: "Iscrivendoti accetti di ricevere email da Abnormal World. Puoi disiscriverti in ogni momento.",
            success: "Iscritto. Controlla la tua casella.",
            error: "Errore durante l'iscrizione.",
            thanks: "Sei dentro.",
            thanksSub: "Ti abbiamo mandato una conferma. A presto.",
        },
        rideCall: {
            eyebrow: "Community Rides",
            title1: "Ride", title2: "Call",
            subtitle: "Pubblica il tuo prossimo giro e trova compagni di pedalata. Niente WhatsApp infiniti, niente fraintendimenti: trail, livello, orario e via.",
            empty: "Nessun ride in programma. Sii il primo a pubblicarne uno.",
            loginRequired: "Per pubblicare o unirti a un ride,",
            loginCta: "fai login alla community",
            newRide: "Pubblica un ride",
            hideForm: "Nascondi form",
            formTitle: "Pubblica il tuo ride",
            date: "Data", time: "Orario",
            trail: "Trail / Combo / Custom", trailPh: "Scegli un trail",
            trailGroup: "Singoli trail",
            comboGroup: "Combo (discesa unica)",
            comboPh: "Scegli una combo",
            modeLabel: "Cosa pubblichi?",
            modeTrail: "Singolo trail",
            modeCombo: "Combo",
            modeCustom: "Giro custom",
            customHint: "Aggiungi i trail nell'ordine in cui li farai (minimo 2, massimo 10). Puoi spostarli su/giù e rimuoverli.",
            customPickPh: "Aggiungi un trail al giro…",
            customAdd: "Aggiungi",
            customEmpty: "Nessun trail aggiunto",
            customMinError: "Aggiungi almeno 2 trail per il giro custom",
            customBadge: "CUSTOM",
            meeting: "Punto di ritrovo", meetingPh: "Es. Parcheggio Convento, ore 09:00",
            level: "Livello", style: "Stile",
            spots: "Spots totali (incluso te)",
            notes: "Note (opzionale)", notesPh: "Ritmo, pause caffè, dopo-giro birra...",
            publish: "Pubblica ride", publishing: "Pubblico…",
            joinedBy: "Joiners",
            spotsLeft: "Spots liberi",
            full: "FULL",
            cancelled: "ANNULLATO",
            host: "HOST",
            join: "Unisciti", joining: "…",
            leave: "Esci dal ride",
            cancel: "Annulla ride",
            confirmCancel: "Annullare questo ride? Non si può tornare indietro.",
            published: "Ride pubblicato. La community può ora unirsi.",
            joined: "Sei dentro. Ci si vede al ritrovo.",
            left: "Sei uscito da questo ride.",
            ridesUpcoming: "Prossimi ride",
            comboBadge: "COMBO",
            levels: {
                chill: "Chill",
                medium: "Medio",
                hard: "Hard",
                enduro: "Pieno Enduro",
            },
            styles: {
                flow: "Flow",
                tech: "Tecnico",
                race: "Race pace",
                tour: "Tour",
                mixed: "Misto",
            },
            today: "Oggi",
            tomorrow: "Domani",
            share: "Condividi",
            shareTitle: "Ride Call · Argentario",
            shareEyebrow: "Ride Call · Argentario",
            shareLevel: "Livello",
            shareStyle: "Stile",
            shareMeet: "Ritrovo",
            shareSpots: "posti liberi",
            shareCta: "Iscriviti su abnormalworld.it",
            lead: "Nessun login, nessun account. Pubblica il tuo prossimo giro, lascia un contatto (WhatsApp o Instagram) e chi vuole partecipare ti scrive direttamente.",
            closeForm: "Chiudi form",
            yourName: "Il tuo nome",
            contactLabel: "Contatto",
            contact: "Scrivi su",
            selectTrail: "Seleziona…",
            customRoute: "Costruisci il giro (min 2 trail)",
            addTrail: "Aggiungi trail",
            meetingPoint: "Punto di ritrovo",
            publishRide: "Pubblica ride",
            upcoming: "Prossimi ride",
            created: "Ride pubblicato. La community può ora contattarti.",
            errNoName: "Inserisci il tuo nome",
            errNoContact: "Inserisci un contatto valido (WhatsApp o IG)",
            errNoMeet: "Inserisci il punto di ritrovo",
            errNoTrail: "Seleziona un trail o una combo",
            errCustomMin: "Aggiungi almeno 2 trail per il giro custom",
        },
        combos: {
            eyebrow: "COMBO LINES",
            title: "Discese uniche",
            subtitle: "Trail che si possono incatenare in una sola discesa, senza dover risalire. Le linee simbolo dell'Argentario quando hai voglia di andare giù finché c'è giù.",
            kmLabel: "Lunghezza", elevLabel: "Dislivello D−", trailsLabel: "Trail",
            exitTitle: "Exit / Bail-out",
            sequenceTitle: "La sequenza",
            partOfCombo: "Parte della combo",
        },
        trailMeta: {
            difficulty: { facile: "Facile", medio: "Medio", hard: "Hard", blue: "Blue", red: "Red", black: "Black" },
            terrain: { roccioso: "Roccioso", tecnico: "Tecnico", flow: "Flow", misto: "Misto" },
        },
        reports: {
            eyebrow: "Trail Reports",
            title: "Come gira oggi",
            empty: "Nessun report ancora. Sii il primo a raccontare com'è andato il giro.",
            loginRequired: "Per pubblicare un report devi essere loggato.",
            loginCta: "Fai login",
            currentStatus: "Status attuale",
            ago: "fa",
            formTitle: "Aggiungi un report",
            ctaBanner: "SEGNALA CONDIZIONE TRAIL",
            ctaBannerSub: "Hai appena girato? Aiuta gli altri. Bastano 30 secondi.",
            condition: "Condizione",
            rating: "Voto",
            comment: "Note (opzionale)",
            commentPh: "Com'era il fondo? Pulito? Vegetazione? Salti rotti? Linea sporca?",
            photo: "Foto (opzionale)",
            submit: "SEGNALA CONDIZIONE",
            submitting: "Pubblico…",
            published: "Report pubblicato. Grazie!",
            deleted: "Report eliminato.",
            delete: "Elimina",
            confirmDelete: "Eliminare questo report?",
            ratingLabel: "stelle",
            conditions: {
                dry: "Asciutto",
                dusty: "Polveroso",
                humid: "Umido",
                wet: "Bagnato",
                mud: "Fango",
                leaves: "Foglie",
                overgrown: "Vegetazione",
                broken: "Linea rotta",
                perfect: "Perfetto",
            },
            share: "Condividi stato",
            shareCopyConfirm: "Copiare questo testo per condividerlo?",
            shareAll: "Condividi situazione trail",
            shareCopied: "Riepilogo copiato. Incollalo dove vuoi.",
            shareTitleSingle: "Stato trail · {name}",
            shareTitleAll: "Argentario Trail Status",
            shareIntroAll: "Situazione trail su Argentario — Abnormalworld",
            shareNoData: "Nessun trail con report recente.",
            shareUpdated: "Aggiornato",
            shareViewAll: "Tutta la situazione",
        },
        whatsapp: {
            cta: "WhatsApp",
            ariaLabel: "Scrivici su WhatsApp",
            prefilledMessage: "Ciao Abnormal, ti scrivo da abnormalworld.it per chiedere info su...",
            beachMessage: "Ciao, scrivo da abnormalworld.it. Vorrei info su tariffe e disponibilità RIVA Beach per il giorno {date}. (Sconto Abnormal)",
            hotelMessage: "Ciao, scrivo da abnormalworld.it. Vorrei info su Hotel Villa Smeraldo. Date: {date}, persone: {people}.",
        },
        stay: {
            eyebrow: "Stay & Recover",
            title1: "Dormi", title2: "qui",
            subtitle: "Dopo il giro ti serve un letto vero, una piscina, una doccia decente e il mare a 200 metri. Villa Smeraldo è la base ufficiale Abnormal World — gestita da chi pedala con voi.",
            hotelEyebrow: "Hotel",
            hotelTitle: "Villa Smeraldo",
            hotelSub: "Hotel 3★ sul Tombolo della Giannella. A conduzione familiare dal 2004. Tra Argentario, mare e laguna di Orbetello.",
            roomsTitle: "Camere & Suite",
            roomsList: {
                matrimoniale: { name: "Matrimoniale", count: "18 camere", desc: "Letto matrimoniale o singoli. Per 2 ospiti." },
                tripla: { name: "Tripla", count: "2 camere", desc: "Fino a 3 ospiti con letto aggiunto. Famiglie o piccoli gruppi." },
                suite: { name: "Suite", count: "2 suite (4 letti)", desc: "Zona giorno + divano letto + terrazzino vista parziale mare." },
                monolocale: { name: "Monolocale", count: "1", desc: "Ingresso indipendente, angolo cottura. Fino a 4 persone." },
                appNew: { name: "Appartamenti (da Luglio)", count: "3 nuovi", desc: "App. 1 (6 posti) · App. 2 (4 posti) · App. 3 (2 posti + divano letto)." },
            },
            servicesTitle: "Servizi pensati per i rider",
            services: {
                bike: { title: "Bike room sicura", desc: "Ricovero protetto per le bici, accesso riservato agli ospiti." },
                pool: { title: "Piscina + Jacuzzi", desc: "Dopo il giro: tuffo, idromassaggio, area solarium." },
                breakfast: { title: "Colazione", desc: "Dolci e caffetteria preparati dallo staff. Iniziamo presto se devi essere sul trail." },
                beachBar: { title: "Beach Bar & Bistrot", desc: "Riva Beach a 200 m: pranzo informale, aperitivi sulla spiaggia." },
                parking: { title: "Parcheggio gratuito", desc: "Ampio parcheggio esterno con videosorveglianza." },
                evCharge: { title: "Ricarica EV", desc: "Colonnina gratuita per auto elettriche degli ospiti." },
                wifi: { title: "Wi-Fi gratuito", desc: "Connessione veloce in tutta la struttura." },
                fitness: { title: "Area fitness", desc: "Attrezzature all'aperto per scarico post-giro." },
                ebike: { title: "Noleggio e-Bike", desc: "Anche per chi non porta la bici: e-bike a noleggio in struttura." },
            },
            partnersTitle: "I nostri partner sul territorio",
            partnerBike: { title: "Officina & Bike Point", desc: "Non abbiamo un'officina interna ma abbiamo un partner di fiducia: Bike Point. Manutenzione, lavaggio, pezzi di ricambio.", link: "Bike Point" },
            partnerShuttle: { title: "Shuttle", desc: "Per i giorni in cui vuoi solo discese: collaboriamo con Tuscan Hill Enduro per i servizi shuttle sui trail dell'Argentario.", link: "Tuscan Hill Enduro" },
            ctaBookTitle: "Prenota subito",
            ctaBookSub: "Miglior prezzo garantito sul sito ufficiale. Nessun costo aggiuntivo.",
            ctaBookBtn: "Prenota su Villa Smeraldo",
            ctaQuoteBtn: "Richiedi preventivo",
            augustBannerTitle: "AGOSTO",
            augustBannerText: "Ad agosto la singola notte non è disponibile. Soggiorno minimo: 7 notti. Per tutto il resto dell'anno la singola notte è ok.",
            riverEyebrow: "Beach",
            riverTitle: "RIVA Beach",
            riverSub: "Lo stabilimento (ex La Goletta) si trova a Giannella, vista Porto Santo Stefano e tramonto sull'Isola d'Elba. A 200 m dall'hotel.",
            riverPerks: "Sconti Abnormal World",
            riverPerksText: "Se ci contatti tramite questo sito, hai sconto sulla giornata al mare E sulle consumazioni. Niente di automatico: scrivici su WhatsApp citando \"Abnormal World\".",
            riverWhatBtn: "Info & sconti via WhatsApp",
            riverFeatures: {
                view: "Vista PSS + tramonto Elba",
                sand: "Sabbia fine, fondale dolce",
                food: "Beach bar, pranzo & aperitivo",
                distance: "200 m dall'hotel",
            },
        },
    },
    en: {
        nav: {
            trail: "Trails", video: "Videos", storia: "Story", community: "Community", eventi: "Events", shop: "Shop", arcade: "Arcade", guide: "Guides", rideCall: "Ride Call", stay: "Stay",
            rides: "Rides", abnormal: "Abnormal", murph: "Murph", trailReport: "Trail Report", story: "Story",
            login: "Login", join: "Join us", logout: "Logout", admin: "Admin", settings: "Settings",
        },
        footer: {
            tagline: "MTB Enduro on Monte Argentario. The hub for trails, photos and community for riders in Tuscany.",
            sections: "Sections", info: "Info", legal: "Legal",
            privacy: "Privacy Policy", cookie: "Cookie Policy", shipping: "Shipping", returns: "Returns & refunds", terms: "Terms of sale",
            madein: "MADE IN ARGENTARIO", copyright: "MTB Enduro Argentario",
        },
        home: {
            eyebrow: "// INDEPENDENT THINKING / ENDURO MTB / ARGENTARIO",
            titleL1: "Abnormal", titleL2: "world", titleL3: "",
            tagline: "Enduro MTB · Monte Argentario",
            subtitle: "Maps help. Curiosity helps more. {n} trails. Zero algorithms.",
            ctaTrails: "Discover Trails",
            ctaReport: "Trail Report",
            ctaVideo: "Watch Videos",
            ctaRide: "Next Ride",
            ctaShop: "Shop Drop",
            ctaCommunity: "Join the Community",
            ctaArcade: "Open Arcade",
            ctaStory: "The Abnormal story",
            howEyebrow: "HOW IT WORKS",
            howTitle1: "Five moves,",
            howTitle2: "zero bullshit.",
            howStep1Title: "Check the trails",
            howStep1Sub: "Status, surface conditions, recent reports.",
            howStep2Title: "Find or post a Ride",
            howStep2Sub: "Publish or join. No endless WhatsApp groups.",
            howStep3Title: "Unlock the challenges",
            howStep3Sub: "Argentario Stages quests, Strava verified, badges.",
            howStep4Title: "Events & community",
            howStep4Sub: "Races, meetups, photos, videos, real people.",
            howStep5Title: "Back the local scene",
            howStep5Sub: "Abnormal gear, local partners, builders.",
            sectionsEyebrow: "Sections", sectionsTitle1: "Find what you", sectionsTitle2: "need",
            qaTrail: { title: "Trails", sub: "Lines and technical info" },
            qaCommunity: { title: "Community", sub: "Riders on Argentario" },
            qaShop: { title: "Shop", sub: "Abnormal apparel" },
            qaArcade: { title: "Arcade", sub: "Challenges. Almost." },
            qaRide: { title: "Ride Call", sub: "Publish rides, find people" },
            qaStay: { title: "Stay & Sea", sub: "Hotel, pool, sea 200 m away" },
            featuredEyebrow: "FEATURED", featuredBadge: "Trail of the month", featuredCta: "Discover trail",
            difficulty: "Difficulty", length: "Length", elevation: "Descent D−",
            communityEyebrow: "COMMUNITY", communityTitle1: "Join the", communityTitle2: "community", communityTitle3: "Abnormal",
            communitySub: "Local riders, photos, tips and shared lines. A simple place for those riding Argentario and those who want to.",
            communityCta: "Enter the community",
            shopEyebrow: "ABNORMAL DROP",
            shopTitle1: "Dress like",
            shopTitle2: "the crew.",
            shopSub: "Every drop comes from the same stuff you find on the trails: mistakes, dust, bruises, hated climbs and lines repeated a thousand times. No catwalk, just real gear.",
            shopCtaAll: "All shop",
        },
        shopPromo: {
            eyebrow: "ABNORMAL DROP",
            title: "Dress like the crew.",
            sub: "Gear made for people who actually ride. Fast shipping, limited sizes.",
            cta: "Open the shop",
        },
        trails: {
            eyebrow: "TRAIL REPORT", title1: "Trails", title2: "Argentario",
            subtitle: "Live status of every Argentario trail, updated by riders: which ones are open, which are closed, which ones need attention. Practical info, technical level, direct links to Komoot and Google Maps.",
            mapTracks: "Track map", trailforks: "Trailforks — Monte Argentario",
            heatmap: "Heatmap", strava: "Strava — Argentario",
            difficulty: "Difficulty", terrain: "Terrain", all: "All",
            easy: "Easy", medium: "Medium", hard: "Hard",
            rock: "Rock", flow: "Flow", technical: "Technical", mixed: "Mixed",
            empty: "No trail matches these filters.", cardCta: "Details",
            badgeMonth: "Trail of the month",
            statusFilter: "Status",
            stateOpen: "Open", stateWarning: "Warning", stateClosed: "Closed", stateUnverified: "To be checked", stateUnverifiedNote: "Status not recently updated: check weather and Trailforks trail reports before riding.",
            statsTotal: "Total trails", statsOpen: "Dry verified", statsWarning: "Wet / warning", statsClosed: "Closed",
            metaTerrain: "Terrain", metaLength: "Length", metaElev: "D−",
            lastUpdated: "Updated",
            justNow: "now", minShort: "min", hourShort: "h", dayShort: "d",
            resetFilters: "Reset filters",
            show: "Show", hide: "Hide",
        },
        weather: {
            eyebrow: "Live weather",
            title: "Argentario right now",
            wind: "Wind", rain: "Rain", feels: "Feels like",
            updated: "Updated", source: "Source: Open-Meteo",
            loading: "Loading weather…", error: "Weather unavailable.",
            forecastTitle: "Next 3 days",
            min: "Min", max: "Max", precip: "Rain",
            today: "Today", tomorrow: "Tomorrow",
            codes: {
                clear: "Clear", mainlyClear: "Mostly clear", partlyCloudy: "Partly cloudy", overcast: "Overcast",
                fog: "Fog", drizzle: "Drizzle", rain: "Rain", heavyRain: "Heavy rain",
                snow: "Snow", thunderstorm: "Thunderstorm", showers: "Showers", unknown: "—", variable: "Variable",
            },
        },
        trailDetail: {
            back: "All trails", line: "THE LINE", tips: "REAL TIPS",
            noteFondo: "SURFACE NOTES",
            video: "VIDEO", map: "MAP", trailforksOpen: "Open on Trailforks", trailforksSub: "GPS track + elevation",
            difficulty: "Difficulty", terrain: "Terrain", length: "Length", elevation: "Descent D−",
            safetyTitle: "SAFETY",
            safetyText: "Helmet and protections required. If a line doesn't feel right, stop and rethink it. Having fun without getting hurt is the basic rule.",
            notFound: "Trail not found", notFoundBack: "← Back to trails", loading: "Loading…",
            openOnMap: "Open on map",
        },
        community: {
            eyebrow: "COMMUNITY",
            title1: "The", title2: "community",
            sub: "Photos, riders, local crews. One place to tell the story of Enduro on Monte Argentario.",
            partnersEyebrow: "WITH US",
            partnersTitle: "Argentario Bike, Tuscan Hill Enduro, Goat Trails and Bike Point support Enduro on Monte Argentario together with Abnormal.",
            riderEyebrow: "LOCAL RIDERS", riderTitle: "The Argentario scene",
            adminMode: "Admin mode", riderEmpty: "Gallery being updated.", riderEmptyAdmin: "No photos yet. Add one from the form above.",
            riderPhoto: "Rider photo", riderName: "Rider name", riderCaption: "Caption (optional)",
            riderSubmit: "Add rider", riderUploading: "Uploading…",
            userEyebrow: "COMMUNITY PHOTOS", userTitle: "Send your photo",
            userSub: "Sign up and upload your group's photos, right from your phone or computer.",
            photo: "Photo", caption: "Caption (optional)", captionPh: "Where, with whom, what happened",
            submit: "Publish photo", submitting: "Publishing…",
            loginReq1: "To upload photos,", loginReq2: "sign up to the community",
        },
        shop: {
            eyebrow: "MERCH", title1: "Shop", title2: "Abnormal",
            sub: "T-shirts, hoodies, caps. Abnormal design, secure Shopify checkout right here.",
            addBtn: "New product",
            empty: "No products yet.", emptyAdmin: "Click \"New product\" to add one.",
            buy: "Buy", soon: "Soon",
        },
        eventi: {
            eyebrow: "Official sponsor",
            title1: "Tuscany Urban", title2: "Cup",
            p1pre: "ABNORMAL is official sponsor of the",
            p1strong: "Tuscany Urban Cup",
            p1post: ", the MTB race circuit that combines Enduro with the urban soul of Tuscany.",
            p2: "All dates, registrations and race updates on the circuit's official Instagram profile.",
        },
        storia: {
            eyebrow: "THE PROJECT",
            title1: "The Project", title2: "Abnormal",
            p1pre: "", p1strong: "ABnormalworld", p1post: " exists to give visibility to the enduro scene on Monte Argentario: trails, builders, riders, events and the people keeping it alive. No fake tourism. The territory seen by those who actually ride it.",
            p2: "No brochures, no agency storytelling. Real photos, real conditions, real people. What you see here is what you find when you load the bike into the car and come to ride.",
            p3: "On the site you'll find: community-updated trail reports, ride calls to organize rides without endless WhatsApp groups, events, Arcade challenges verified via Strava, guides, gallery, local partners and Abnormal gear.",
            p4: "A growing community, tied to the trails, the people, and everything around real MTB. Come ride with us.",
        },
        auth: {
            loginEyebrow: "LOGIN", loginTitle: "Sign in.",
            loginSub: "No socials, just email. Fast and effective.",
            email: "Email", password: "Password",
            loginBtn: "Login", loginBusy: "…",
            noAccount: "No account yet?", goRegister: "Sign up",
            forgot: "Forgot password?",
            regEyebrow: "JOIN US", regTitle: "Inside.",
            regSub: "Upload photos, ride the lines, leave your mark.",
            name: "Name or Nickname", passwordMin: "Password (min. 6)",
            regBtn: "Sign up",
            hasAccount: "Already have an account?", goLogin: "Login",
            welcomeBack: "Welcome back. Ride hard.", welcomeNew: "Welcome to the Abnormal community.",
            forgotEyebrow: "FORGOT PASSWORD",
            forgotTitle: "Recover access.",
            forgotSub: "Enter the email you signed up with. If the account exists, we'll send you a link to choose a new password (valid for 1 hour).",
            forgotBtn: "Send link",
            forgotSent: "If your email is registered, check your inbox in a few seconds.",
            backToLogin: "Back to login",
            resetEyebrow: "RESET PASSWORD",
            resetTitle: "New password.",
            resetSub: "Pick a strong password. Minimum 6 characters.",
            resetBtn: "Update password",
            resetOk: "Password updated. You can sign in now.",
            resetMissing: "Missing or invalid token. Request a new link.",
        },
        cookie: {
            message: "This site uses technical cookies and, with your consent, analytics cookies. Accept all, reject or read our",
            messageLink: "Cookie Policy",
            accept: "Accept", decline: "Essentials only", settings: "Preferences",
        },
        guide: {
            eyebrow: "Argentario Guides",
            title1: "Argentario", title2: "Guides",
            subtitle: "Real guides for those coming to ride Argentario or living here and wanting to squeeze more out of the trails. No brochures. Just useful info, local intel and some dust in the teeth.",
            empty: "Guides coming soon.",
            read: "Read guide",
            back: "All guides",
            notFound: "Guide not found",
            relatedTrails: "Related trails",
            beforeTitle: "Before you ride",
            beforeText: "Trails change. Rain, wind, maintenance, heat and constant traffic can change the surface from one day to the next. Before planning a ride, always check the latest status on Trailforks, Strava, Argentario Bike or ask the local community.",
            beforeCta: "Check trail status",
            quickEyebrow: "Trail Quick Notes",
            quickSub: "Two dirty lines on the most-mentioned Argentario trails. Not a substitute for a guide, but they keep you from leaving completely blind.",
            outro: "ABNORMAL doesn't sell the perfect-trail fairy tale. It tells the territory as it is: beautiful, rough, technical, alive. Respect it and it gives back a lot. Take it lightly and it teaches you a couple of things.",
        },
        common: {
            error: "Error",
            loading: "Loading…",
            uploadFile: "Upload file",
            uploading: "Uploading…",
            confirmPassword: "Confirm password",
            passwordsMismatch: "Passwords don't match",
            share: "Share",
            shareTrail: "Share trail",
            copyLink: "Copy link",
            copyCaption: "Copy IG caption",
            copied: "Copied to clipboard",
            copyFail: "Couldn't copy",
            uploadPhotoFirst: "Upload a photo.",
            uploadOrPaste: "Upload a photo or paste a URL.",
            save: "Save",
            publish: "Publish",
            soonDesc: "Levels, ranking, real challenges and events — coming soon.",
        },
        arcade: {
            insertCoin: "★ INSERT COIN ★ INSERT COIN ★",
            tagline: "> NOT A GAME. ALMOST.",
            sub1: "> EVERY LEVEL IS A REAL CHALLENGE.",
            sub2: "> FOR THOSE WHO DON'T MAKE EXCUSES.",
            unlocking: "UNLOCKING SOON…",
            ready: "READY PLAYER ONE",
            prepare: "PREPARE YOURSELF",
            copy: "Levels, ranking, real challenges and events — coming soon.",
            copy2: "Stage 1 playable. The others will unlock.",
            hiscore: "HI-SCORE COMING SOON",
        },
        newsletter: {
            eyebrow: "Newsletter",
            title1: "Stay in the", title2: "loop",
            sub: "No spam. Just new trail lines, Argentario events and shop drops. One email when there's actually something to say.",
            placeholder: "your@email.com",
            cta: "Subscribe", busy: "Sending…",
            consent: "By subscribing you agree to receive emails from Abnormal World. You can unsubscribe anytime.",
            success: "Subscribed. Check your inbox.",
            error: "Subscription failed.",
            thanks: "You're in.",
            thanksSub: "We just sent a confirmation. Talk soon.",
        },
        rideCall: {
            eyebrow: "Community Rides",
            title1: "Ride", title2: "Call",
            subtitle: "Publish your next ride and find people to share the trail with. No endless WhatsApp groups, no misunderstandings: trail, level, time, go.",
            empty: "No rides planned yet. Be the first to publish one.",
            loginRequired: "To publish or join a ride,",
            loginCta: "log in to the community",
            newRide: "Publish a ride",
            hideForm: "Hide form",
            formTitle: "Publish your ride",
            date: "Date", time: "Time",
            trail: "Trail / Combo / Custom", trailPh: "Pick a trail",
            trailGroup: "Single trails",
            comboGroup: "Combos (single descent)",
            comboPh: "Pick a combo",
            modeLabel: "What are you publishing?",
            modeTrail: "Single trail",
            modeCombo: "Combo",
            modeCustom: "Custom ride",
            customHint: "Add the trails in the order you'll ride them (minimum 2, max 10). You can reorder and remove them.",
            customPickPh: "Add a trail to the ride…",
            customAdd: "Add",
            customEmpty: "No trails added yet",
            customMinError: "Add at least 2 trails for a custom ride",
            customBadge: "CUSTOM",
            meeting: "Meeting point", meetingPh: "e.g. Convento parking, 09:00",
            level: "Level", style: "Style",
            spots: "Total spots (you included)",
            notes: "Notes (optional)", notesPh: "Pace, coffee breaks, post-ride beer…",
            publish: "Publish ride", publishing: "Publishing…",
            joinedBy: "Joiners",
            spotsLeft: "Spots left",
            full: "FULL",
            cancelled: "CANCELLED",
            host: "HOST",
            join: "Join", joining: "…",
            leave: "Leave ride",
            cancel: "Cancel ride",
            confirmCancel: "Cancel this ride? No undo.",
            published: "Ride published. The community can now join.",
            joined: "You're in. See you at the meeting point.",
            left: "You left this ride.",
            ridesUpcoming: "Upcoming rides",
            comboBadge: "COMBO",
            levels: {
                chill: "Chill",
                medium: "Medium",
                hard: "Hard",
                enduro: "Full Enduro",
            },
            styles: {
                flow: "Flow",
                tech: "Tech",
                race: "Race pace",
                tour: "Tour",
                mixed: "Mixed",
            },
            today: "Today",
            tomorrow: "Tomorrow",
            share: "Share",
            shareTitle: "Ride Call · Argentario",
            shareEyebrow: "Ride Call · Argentario",
            shareLevel: "Level",
            shareStyle: "Style",
            shareMeet: "Meet at",
            shareSpots: "spots left",
            shareCta: "Join on abnormalworld.it",
            lead: "No login, no account. Publish your next ride, leave a contact (WhatsApp or Instagram) and whoever wants to join will hit you up directly.",
            closeForm: "Close form",
            yourName: "Your name",
            contactLabel: "Contact",
            contact: "Message on",
            selectTrail: "Select…",
            customRoute: "Build the ride (min 2 trails)",
            addTrail: "Add trail",
            meetingPoint: "Meeting point",
            publishRide: "Publish ride",
            upcoming: "Upcoming rides",
            created: "Ride published. The community can now contact you.",
            errNoName: "Enter your name",
            errNoContact: "Enter a valid contact (WhatsApp or IG)",
            errNoMeet: "Enter the meeting point",
            errNoTrail: "Select a trail or combo",
            errCustomMin: "Add at least 2 trails for a custom ride",
        },
        combos: {
            eyebrow: "COMBO LINES",
            title: "Single-descent combos",
            subtitle: "Trails you can link into one descent, no climb in between. The lines that define Argentario when you just want to drop until there's nothing left to drop.",
            kmLabel: "Length", elevLabel: "Descent D−", trailsLabel: "Trails",
            exitTitle: "Exit / Bail-out",
            sequenceTitle: "The sequence",
            partOfCombo: "Part of the combo",
        },
        trailMeta: {
            difficulty: { facile: "Easy", medio: "Medium", hard: "Hard", blue: "Blue", red: "Red", black: "Black" },
            terrain: { roccioso: "Rocky", tecnico: "Technical", flow: "Flow", misto: "Mixed" },
        },
        reports: {
            eyebrow: "Trail Reports",
            title: "How the trail rides today",
            empty: "No reports yet. Be the first to share how the trail rode.",
            loginRequired: "You must be logged in to post a report.",
            loginCta: "Log in",
            currentStatus: "Current status",
            ago: "ago",
            formTitle: "Add a report",
            ctaBanner: "REPORT TRAIL CONDITION",
            ctaBannerSub: "Just rode it? Help the others. 30 seconds.",
            condition: "Condition",
            rating: "Rating",
            comment: "Notes (optional)",
            commentPh: "How was the surface? Clean? Overgrown? Broken jumps? Dirty line?",
            photo: "Photo (optional)",
            submit: "REPORT CONDITION",
            submitting: "Publishing…",
            published: "Report published. Thanks!",
            deleted: "Report deleted.",
            delete: "Delete",
            confirmDelete: "Delete this report?",
            ratingLabel: "stars",
            conditions: {
                dry: "Dry",
                dusty: "Dusty",
                humid: "Humid",
                wet: "Wet",
                mud: "Mud",
                leaves: "Leaves",
                overgrown: "Overgrown",
                broken: "Broken line",
                perfect: "Perfect",
            },
            share: "Share status",
            shareCopyConfirm: "Copy this text to share?",
            shareAll: "Share trail status",
            shareCopied: "Summary copied. Paste it anywhere.",
            shareTitleSingle: "Trail status · {name}",
            shareTitleAll: "Argentario Trail Status",
            shareIntroAll: "Argentario trails status — Abnormalworld",
            shareNoData: "No trail has a recent report.",
            shareUpdated: "Updated",
            shareViewAll: "Full status",
        },
        whatsapp: {
            cta: "WhatsApp",
            ariaLabel: "Write us on WhatsApp",
            prefilledMessage: "Hi Abnormal, I'm writing from abnormalworld.it to ask info about...",
            beachMessage: "Hi, writing from abnormalworld.it. I'd like info on RIVA Beach rates and availability for {date}. (Abnormal discount)",
            hotelMessage: "Hi, writing from abnormalworld.it. I'd like info on Hotel Villa Smeraldo. Dates: {date}, people: {people}.",
        },
        stay: {
            eyebrow: "Stay & Recover",
            title1: "Sleep", title2: "here",
            subtitle: "After the ride you need a real bed, a pool, a decent shower and the sea 200 m away. Villa Smeraldo is the official Abnormal World base — run by people who actually ride with you.",
            hotelEyebrow: "Hotel",
            hotelTitle: "Villa Smeraldo",
            hotelSub: "3★ hotel on the Giannella sandbar. Family-run since 2004. Between Argentario, sea and Orbetello lagoon.",
            roomsTitle: "Rooms & Suites",
            roomsList: {
                matrimoniale: { name: "Double", count: "18 rooms", desc: "Double bed or twin. For 2 guests." },
                tripla: { name: "Triple", count: "2 rooms", desc: "Up to 3 guests with an extra bed. Families or small groups." },
                suite: { name: "Suite", count: "2 suites (4 beds)", desc: "Living area + sofa bed + small balcony with partial sea view." },
                monolocale: { name: "Studio", count: "1", desc: "Independent entrance, kitchenette. Up to 4 people." },
                appNew: { name: "Apartments (from July)", count: "3 new", desc: "Apt. 1 (6 beds) · Apt. 2 (4 beds) · Apt. 3 (2 beds + sofa bed)." },
            },
            servicesTitle: "Services built for riders",
            services: {
                bike: { title: "Secure bike room", desc: "Locked storage for bikes, guests only access." },
                pool: { title: "Pool + Jacuzzi", desc: "After the ride: dip, hydromassage, solarium area." },
                breakfast: { title: "Breakfast", desc: "Pastries and coffee made by our staff. Early-start friendly if you need to be on the trail." },
                beachBar: { title: "Beach Bar & Bistrot", desc: "Riva Beach 200 m away: informal lunch, sunset spritz on the sand." },
                parking: { title: "Free parking", desc: "Wide outdoor parking with CCTV." },
                evCharge: { title: "EV charging", desc: "Free charging station for guests' electric cars." },
                wifi: { title: "Free Wi-Fi", desc: "Fast connection across the whole property." },
                fitness: { title: "Fitness area", desc: "Outdoor equipment for post-ride decompression." },
                ebike: { title: "E-bike rental", desc: "Even if you didn't bring your bike: e-bikes for rent on site." },
            },
            partnersTitle: "Our local partners",
            partnerBike: { title: "Workshop & Bike Point", desc: "We don't have an internal workshop but we have a trusted partner: Bike Point. Service, wash, spare parts.", link: "Bike Point" },
            partnerShuttle: { title: "Shuttle", desc: "For descent-only days: we work with Tuscan Hill Enduro for shuttle service on Argentario trails.", link: "Tuscan Hill Enduro" },
            ctaBookTitle: "Book now",
            ctaBookSub: "Best price guaranteed on the official site. No extra fees.",
            ctaBookBtn: "Book on Villa Smeraldo",
            ctaQuoteBtn: "Request a quote",
            augustBannerTitle: "AUGUST",
            augustBannerText: "In August single-night stays are not available. Minimum stay: 7 nights. For the rest of the year, single night is fine.",
            riverEyebrow: "Beach",
            riverTitle: "RIVA Beach",
            riverSub: "Our beach club (formerly La Goletta) is on Giannella, facing Porto Santo Stefano with sunset over Elba island. 200 m from the hotel.",
            riverPerks: "Abnormal World discounts",
            riverPerksText: "If you contact us through this site you get a discount on both the day at the beach AND food/drinks. Nothing automatic: drop us a WhatsApp message mentioning \"Abnormal World\".",
            riverWhatBtn: "Info & discounts via WhatsApp",
            riverFeatures: {
                view: "PSS view + Elba sunset",
                sand: "Fine sand, gentle seabed",
                food: "Beach bar, lunch & spritz",
                distance: "200 m from the hotel",
            },
        },
    },
};
